import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatMessage } from '../Components/Shared/API/ApiTypes';

interface ChatState {
  messages: ChatMessage[];
}

const initialState: ChatState = {
  messages: [], // initial chat history can be seeded elsewhere
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<ChatMessage>) {
      state.messages.push(action.payload);
    },
    updateTempMessage(state, action: PayloadAction<ChatMessage>) {
      const last = state.messages[state.messages.length - 1];
      if (last && last.temp) {
        Object.assign(last, action.payload);
      }
    },
  },
});

export const { addMessage, updateTempMessage } = chatSlice.actions;
export default chatSlice.reducer;
